<template>
	<path d="M12 13a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="currentColor" />
	<path d="M16.95 7.05a7 7 0 010 9.9M7.05 16.95a7 7 0 010-9.9M19.78 4.22a11 11 0 010 15.56M4.22 19.78a11 11 0 010-15.56"
		fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
</template>
